module.exports = __webpack_public_path__ + "media/images/sp/page_common/keywords/keyword_okunaiteien-7da7958f24baa2698f630a8a2ac39e19.jpg";